import sendRequest from './sendRequest';

const BASE_PATH = 'api';

export const verifyEmail = data =>
    sendRequest(`${BASE_PATH}/customer/ValidateEmail`, {
        body: JSON.stringify(data),
    });

export const registerUser = data =>
    sendRequest(`${BASE_PATH}/customer/RegisterUser`, {
        body: JSON.stringify(data),
    });

export const authlogin = data =>
    sendRequest(`${BASE_PATH}/Customer/Login`, {body: JSON.stringify(data)}, data.xShopId ? {xShopId : data.xShopId} : {});

export const changePassword = data =>
    sendRequest(`${BASE_PATH}/customer/myspace/ChangePassword`, {
        body: JSON.stringify(data),
        method: 'PUT',
    });

export const activateAccount = data =>
    sendRequest(`${BASE_PATH}/customer/ActivationAccount`, {
        body: JSON.stringify(data),
        method: 'POST',
    });

export const forgotPassword = data =>
    sendRequest(`${BASE_PATH}/Customer/Forgotpassword`, {
        body: JSON.stringify(data),		
        method: 'POST',
    }, data.xShopId ? {xShopId : data.xShopId} : {});

export const resetPassword = data =>
    sendRequest(`${BASE_PATH}/Customer/Resetpassword`, {
        body: JSON.stringify(data),
        method: 'POST',
    });

export const socialLogin = data =>
    sendRequest(`${BASE_PATH}/Customer/SocialLogin`, {
        body: JSON.stringify(data),
    });

export const validationEmail = data =>
    sendRequest(`${BASE_PATH}/Customer/SendValidationEmail?email=${data}&type=2`, {
        method: 'POST',
    });
